<template>
  <footer>
    <div class="linkedIn">
      <a
        href="https://www.linkedin.com/in/pascal-de-lucia-4a32b818/"
        target="_blank"
      >
        <img
          src="../assets/LinkedIn_icon_circle.png"
          alt="../assets/LinkedIn_icon_circle.png"
        />
      </a>
    </div>
    <p>
      {{ $t("Footer") }}
    </p>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent"
};
</script>

<style lang="scss" scoped>
footer {
  height: fit-content;
  padding: 2rem 4rem;
  text-align: center;
  color: black;
  font-weight: bold;
  background-color: white;
  position: relative;
  margin-top: 0;
  z-index: 1;

  p {
    margin-top: 1rem;
    margin-bottom: 1rem;
    font-size: 0.8rem;
  }
  .linkedIn {
    position: absolute;
    top: 20px;
    left: 30px;
    img {
      width: 40px;
    }
  }
}

@media only screen and (min-width: 600px) {
  footer {
    margin-top: 0;
    padding: 1.5rem 4rem;
    p {
      font-size: 1rem;
      margin-top: 1rem;
      margin-bottom: 1rem;
    }

    .linkedIn {
      top: 20px;
      left: 60px;
    }
  }
}
</style>
